import Script from "next/script";
import { getPublicRuntimeConfig, isDev } from "../../config";
import { useRouteChange } from "../../core/hooks/useRouteChange";

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

export function trackEvent(data: { event: string; [key: string]: unknown }) {
  if (Array.isArray(window.dataLayer)) {
    window.dataLayer.push(data);
  }

  if (isDev) {
    // eslint-disable-next-line no-console
    console.log("Track Event", data);
  }
}

export function trackGPLEvent(
  name: string,
  args?: { action?: string; category?: "Procedure"; label?: string },
) {
  trackEvent({
    event: `GPL::${name}`,
    eventAction: args?.action,
    eventCategory: args?.category,
    eventLabel: args?.label,
  });
}

export function GoogleTagManagerProvider() {
  const { gtmId } = getPublicRuntimeConfig();

  useRouteChange((url: string) => {
    trackEvent({ event: "route-change", route: url });
  });

  return gtmId ? (
    <Script
      id="google-tag-manager-script"
      dangerouslySetInnerHTML={{
        __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','${gtmId}');`,
      }}
    />
  ) : null;
}
